module.exports = __webpack_public_path__ + "static/images/edit-pencil.5e98cdf504b6ee1b33c59ce914a6737e.svg";